export default "__VITE_ASSET__D_yemFz9__"